import PeopleProvider from '@/contexts/PeopleProvider';
import DashboardLayout from '@/layouts/Dashboard';
import { useLeveragedAndCommittedActions } from '@/services/action/hooks';
import { useCategories } from '@/services/categories/hooks';
import rem from '@/utils/rem';
import { Flex, Spinner } from '@chakra-ui/react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import People from './people';

function PeopleWrapper() {
  const { t } = useTranslation('People');
  const { isLoading: isActionsLoading } = useLeveragedAndCommittedActions();
  const { isLoading: isCategoriesLoading } = useCategories();

  return (
    <PeopleProvider>
      <DashboardLayout pageTitle={t('pageTitle')} paddingInline="0" paddingTop="0">
        {isActionsLoading || isCategoriesLoading ? (
          <Flex alignItems="center" justifyContent="center" marginTop={rem(128)}>
            <Spinner size="xl" />
          </Flex>
        ) : (
          <People />
        )}
      </DashboardLayout>
    </PeopleProvider>
  );
}

export default memo(PeopleWrapper);
